// extracted by mini-css-extract-plugin
export default {"panel":"seIzNc","hideInfo":"BJMnj0","detailsTitle":"zaEvLG","detailsText":"n0irHm","searchFadeIn":"spqHlK"};